



















































import { Component, Mixins, Watch } from "vue-property-decorator";
import { TextItemOption, ComboBoxItem } from "../../../../domain/document/items";
import { Rectangle } from "../../../../domain/drawing";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { ComboBoxObjectStyleReader } from "../styleReaders";
import {
  OptionSelectableStyledTextEditableObjectMixin
} from "./mixins";
import ComboBoxMenuObject from "./comboBox/ComboBoxMenuObject.vue";
import ComboBoxMenuItemObject from "./comboBox/ComboBoxMenuItemObject.vue";
import TextInputArea from "./TextInputArea.vue";
import { IFreeInputableObject } from "./IFreeInputableObject";

@Component({
  components: {
    ComboBoxMenuObject,
    ComboBoxMenuItemObject,
    TextInputArea,
  },
})
export default class ComboBoxObject extends Mixins(
  OptionSelectableStyledTextEditableObjectMixin
) implements IFreeInputableObject {
  private static readonly markWidth = 14;

  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new ComboBoxObjectStyleReader(configuration.style.document.editor.objects.comboBox);
  }

  editingSource: ComboBoxItem;

  get displayText(): string {
    this.updateTextPositionHeight();
    if (this.shouldInputFreeSelfOrAll) { // フリー入力
      return this.label;
    } else if (this.isBlank) { // コンボボックス選択（未選択）
      return "--";
    } else if (this.shouldShowMark && !this.textStyle.isMultiLine) {  // コンボボックス選択（マーカーあり＆単数行）
      return this.getExtentText();  // 表示しきれない場合に切り詰めた文字列を返す
    } else { // コンボボックス選択
      return this.label;
    }
  }

  set displayText(value: string) {
    this.label = value;
  }

  private getExtentText(): string {
    const overwrite = "…";
    const rectangle = this.getComboBoxRect();
    const comboBoxWidth = rectangle ? rectangle.width : this.width;
    const width = comboBoxWidth - ComboBoxObject.markWidth;
    const original = this.$measureTextDrawnSize(this.label, this.textStyle);
    if (original.width < width) {
      return this.label;
    }
    for (let i = this.label.length - overwrite.length; i > 0; i--) {
      const text = this.label.substring(0, i) + overwrite;
      const size = this.$measureTextDrawnSize(text, this.textStyle);
      if (size.width < width) {
        return text;
      }
    }
    return overwrite;
  }

  private resetDisplayText(): void {
    this.$nextTick(() => {
      // 再評価のトリガーを与えたいだけなので値は変更せずにクローンだけさせている
      // リアクティブをうまいこと使えればよいのだが・・
      this.writePropertyWhenValid(o => {});
    });
  }

  get containerStyleProperties() {
    return {
      paddingRight: this.shouldShowMark ? (ComboBoxObject.markWidth + "px") : null,
    };
  }

  get focusedGeometryStyleProperties(): any {
    const geometryStyle = this.absoluteGeometryStyleProperties;
    const geometryWidth = parseInt(geometryStyle.width, 10);
    return {
      left: geometryStyle.left,
      top: geometryStyle.top,
      width: (geometryWidth + ComboBoxObject.markWidth) + "px",
      height: geometryStyle.height,
    };
  }

  updateInputElement(value: HTMLInputElement): void {
    this.inputableElement = value;
  }

  @Watch("shouldInputFreeSelfOrAll")
  onShouldInputFreeUpdated(newValue: boolean, oldValue: boolean) {
    this.onFocus();
    if (newValue || this.isOptionSelected) { return; }
    this.applySelectedOption(this.findOptionToSelect());
  }

  private applySelectedOption(value: TextItemOption): void {
    const nextOption
      = this.shouldInputFreeSelfOrAll ? null
      : (value != null) ? value
      : this.options[0];
    if (this.selectedOption !== nextOption) {
      this.selectedOption = nextOption;
    }
    this.isOpen = false;
  }

  isOpen: boolean = false;

  onFocus(): void {
    // フリー入力時、comboBoxContainerにフォーカスを当てるとフリー入力オブジェクトのフォーカスを奪い入力出来なくなる場合がある
    if (!this.shouldInputFreeSelfOrAll) {
      (this.$refs.comboBoxContainer as HTMLElement).focus();
    }
    this.emitFocus();
  }

  onKeydown(event: KeyboardEvent): void {
    switch (event.key) {
      case "Up":
      case "ArrowUp":
        event.preventDefault();
        this.toSelectPrevOption();
        break;
      case "Down":
      case "ArrowDown":
        event.preventDefault();
        this.toSelectNextOption();
        break;
      // 以下のキーはv1で実装されている挙動であるが、一般的なUIとは思えないのでとりあえず保留しておく
      // case "Home":
      // case "PageUp":
      //   event.preventDefault();
      //   this.toSelectFirstOption();
      //   break;
      // case "End":
      // case "PageDown":
      //   event.preventDefault();
      //   this.toSelectLastOption();
      //   break;
    }
  }

  @Watch("isFocused")
  onIsFocusedUpdated(newValue: boolean, oldValue: boolean) {
    if (!newValue) {
    this.isOpen = false;
    }
    this.resetDisplayText();
  }

  openMenu(mousedown: PointerEvent) {
    if (this.shouldInputFreeSelfOrAll) {
      return;
    }
    this.emitFocus();
    if (mousedown.button === 2 || this.isEditDisabledByRuleSet) { return; }
    this.isOpen = true;
  }

  get menuStyleProperties() {
    const rect = this.getComboBoxRect();
    // TODO:zIndexの検討
    // 1.現状はではObjectに振られているzIndexが優先されている
    // 2.Objectに振られているzIndexを無くした場合でも、プルダウンにzIndex指定しないと他のObjectの下に表示されてしまう
    return this.shouldDrawMenuOnTheTop()
      ? {
        bottom: rect.height + "px",
        left: "-1px",
        minWidth: rect.width + "px",
      }
      : {
        top: rect.height - 1 + "px",
        left: "-1px",
        minWidth: rect.width + "px",
      };
  }

  shouldDrawMenuOnTheTop(): boolean {
    // プルダウンをコンボボックスの上に描画させるかどうか
    // コンボボックスの下にプルダウンを描画したらページからはみ出るかどうかで判定
    // (container.offsetTop + containerRect.height + comboBoxMenuMaxHeight) > container.offsetParent.scrollHeight
    // (画面上部からコンボボックスまでの高さ ＋ コンボボックスの高さ ＋ プルダウンのMaxHeight(200px)) ＞ ページの高さ
    const comboBoxMenuMaxHeight = 200; // ComboBoxMenuObject.vue で指定されている
    const container = this.$refs.comboBoxContainer as HTMLElement;
    const containerRect = container ? container.getBoundingClientRect() : null;
    return containerRect && container.offsetParent
      && container.offsetTop > comboBoxMenuMaxHeight
      && (container.offsetTop + containerRect.height + comboBoxMenuMaxHeight) > container.offsetParent.scrollHeight;
  }

  private getComboBoxRect(): Rectangle {
    const container = this.$refs.comboBoxContainer as HTMLElement;
    const rect = container ? container.getBoundingClientRect() as DOMRect : null;
    return rect ? Rectangle.from({ x: rect.x, y: rect.y, width: rect.width, height: rect.height }).multiply(1 / this.scale) : null;
  }

  get freeInputText(): string {
    return this.label;
  }

  set freeInputText(value: string) {
    this.label = value;
  }

  get isBlank(): boolean {
    if (!this.selectedOption) { return false; }
    // 不具合で選択状態とlabelが不整合になってしまっているデータがあるので、labelがある場合はそれを表示するようにしている
    return this.selectedOption.name && !this.selectedOption.text && !this.selectedOption.code && !this.selectedOption.score && !this.label;
  }

  adjustTextFontSize(): void {
    if (!this.editingSource.isEmpty) {
      this.autoAdjustFontSize();
    }
  }

  inputStyleProperties(): any {
    return {
      userSelect: this.shouldInputFreeSelfOrAll ? null : "none",
    };
  }

  pasteText(value: string): void {
    this.insertTextToCaretPosition(value);
    this.$nextTick(() => {
      this.adjustTextFontSize();
    });
  }

  overwriteText(value: string, isForcibly?: boolean): void {
    console.error("overwriteTextは実装されていません。");
  }

  get shouldShowMark(): boolean {
    return (this.$configuration.style.document.editor.objects.comboBox.mark.visibleObjectWidth <= this.width) && !this.shouldInputFreeSelfOrAll && !this.isEditDisabledByRuleSet;
  }
}

